import { Button, ButtonProps } from '@servicetitan/anvil2';

export const navigateToReturnUrl = (returnUrl: string) => {
    (window.top ?? window).location.href = returnUrl;
};

export const BackToWebsiteButton = ({
    returnUrl,
    appearance = 'secondary',
    children = 'Back To Website',
    ...buttonProps
}: { returnUrl: string } & ButtonProps) => {
    return (
        <Button
            appearance={appearance}
            onClick={() => navigateToReturnUrl(returnUrl)}
            {...buttonProps}
        >
            {children}
        </Button>
    );
};
